<div class="container" (click)="onClick($event)">
  <span>{{ label | translate }}</span>
  <img [src]="getChevron" />
</div>
